import React from 'react'
import { useGlobalState } from 'state'
import { LAYERS } from 'common/layers'

export const BorderLayer = () => {
  const state = useGlobalState()

  const hasShinsuiR6T10 = React.useMemo(() => state.app.hazardMapIds.includes('ShinsuiR6T10'), [state.app.hazardMapIds])

  React.useEffect(() => {
    state.map.setLayoutVisibility(LAYERS.SHINSUI_R06.id, hasShinsuiR6T10)
  }, [hasShinsuiR6T10])

  return (
    <></>
  )
}
